<template>
    <div>
        <p class="is-italic has-text-info clarity-mask">
            <template v-if="isKata">
                {{
                    translate("audit_logs.template.fightResultRevertedKata", false, [
                        context.categoryName,
                        registrationLabel(context.firstEventRegistrationId, context.firstCompetitorName),
                    ])
                }}
            </template>
            <template v-else>
                {{
                    translate("audit_logs.template.fightResultReverted", false, [
                        context.categoryName,
                        registrationLabel(context.firstEventRegistrationId, context.firstCompetitorName),
                        registrationLabel(context.secondEventRegistrationId, context.secondCompetitorName),
                    ])
                }}
            </template>
        </p>
        <p>
            {{ translate("common.category") }}: <span class="has-text-weight-bold">{{ context.categoryName }}</span
            >, {{ translate("common.round") }}:
            <span class="has-text-weight-bold">
                <FightRoundName :round-name="context.fightRound" :bracket-level="context.bracketLevel" />
            </span>
            <template v-if="context.fightNumber">
                ,
                {{ translate("common.fight_number") }}:
                <span class="tag is-white">#{{ context.fightNumber }}</span>
            </template>
            <template v-if="context.matName && context.matName !== '---'">
                , {{ translate("common.mat") }}: <span class="has-text-weight-bold">{{ context.matName }}</span>
            </template>
        </p>
        <p v-if="isKata" class="clarity-mask">
            {{ translate("common.competitor") }}:
            <span class="has-text-weight-bold">{{ registrationLabel(context.firstEventRegistrationId, context.firstCompetitorName) }}</span>
        </p>
        <p v-else class="clarity-mask">
            {{ translate("common.competitors") }}:
            <span class="has-text-weight-bold">{{ registrationLabel(context.firstEventRegistrationId, context.firstCompetitorName) }}</span>
            vs.
            <span class="has-text-weight-bold">{{
                registrationLabel(context.secondEventRegistrationId, context.secondCompetitorName)
            }}</span>
        </p>
        <p>
            {{ translate("audit_logs.fight_revert_reason_label") }}:
            <span class="has-text-weight-bold">{{ translate(`audit_logs.fight_revert_reason.${context.reason}`) }}</span>
        </p>
    </div>
</template>

<script setup lang="ts">
    import { computed } from "vue";
    import { FightResultReverted } from "../../Api/auditLogsApi";
    import { translate } from "../../Common/translations";
    import { User, BracketTypeEnum } from "../../Common/types";
    import FightRoundName from "../../Common/FightRoundName.vue";
    import { registrationLabel } from "./registrationLabel";

    const props = defineProps<{
        context: FightResultReverted;
        user: User;
    }>();

    const isKata = computed(() => props.context.bracketType === BracketTypeEnum.Kata);
</script>

<style scoped></style>
